import { render, staticRenderFns } from "./SprFestModal.vue?vue&type=template&id=9b8384e0&scoped=true&"
import script from "./SprFestModal.vue?vue&type=script&lang=tsx&"
export * from "./SprFestModal.vue?vue&type=script&lang=tsx&"
import style0 from "./SprFestModal.vue?vue&type=style&index=0&lang=less&"
import style1 from "./SprFestModal.vue?vue&type=style&index=1&id=9b8384e0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8384e0",
  null
  
)

export default component.exports